module.exports = __webpack_public_path__ + "static/media/country_mg.35444837.webp";